import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { Observable, of } from 'rxjs';

import { MessageService } from './message.service';
import { ISpringResponseBody } from '@app/shared/interfaces/response-interfaces';
import { TranslateService } from '@ngx-translate/core';
import { ServerError } from '@app/shared/mock/response-types.examples';
import { Store } from '@ngrx/store';
import { ActionAuthLogout } from '@app/core';

/** Type of the handleError function returned by HttpErrorHandler.createHandleError */
export type HandleError =
    (operation?: string) => (error: HttpErrorResponse) => Observable<ISpringResponseBody>;

/** Handles HttpClient errors */
@Injectable()
export class HttpErrorHandler {
    constructor(
        private messageService: MessageService,
        private translateService: TranslateService,
        private store: Store<any>
    ) { }

    /** Create curried handleError function that already knows the service name */
     createHandleError = (serviceName = '') => (operation = 'operation') => this.handleError(serviceName, operation);

    /**
     * Returns a function that handles Http operation failures.
     * This error handler lets the app continue to run as if no error occurred.
     * @param serviceName = name of the data service that attempted the operation
     * @param operation - name of the operation that failed
     */
    handleError(serviceName = '', operation = 'operation') {

        return (e: HttpErrorResponse): Observable<ISpringResponseBody> => {
            if (e.error && e.error.status) {
                if (e.error.status === 401) {
                    this.store.dispatch(new ActionAuthLogout(true));
                    return of(this.setResponse('info.sessionEnded'));
                }
                console.log('ERROR - HttpErrorResponse', e);
                return of(e.error);
            } else {
                // TODO: send the error to remote logging infrastructure
                console.error(`server error caught at ${serviceName}: ${operation}`, e); // log to console instead

                const message = (e.error instanceof ErrorEvent) ?
                    e.error.message :
                    `server returned code ${e.status} with body "${e.error}"`;

                // TODO: better job of transforming error for user consumption
                this.messageService.add(`${serviceName}: ${operation} failed: ${message}`);
                // Let the app keep running by returning a safe result.
                return of(this.setResponse('info.defaultError'));
            }
        };
    }

    private setResponse(msgCode: string): ISpringResponseBody {
        return {
            code: ServerError.code,
            status: ServerError.status,
            message: this.translateService.instant(msgCode)
        } as ISpringResponseBody;
    }

}
